import { useState } from 'react';
import { IoCopyOutline } from 'react-icons/io5';
import { PiWhatsappLogo } from 'react-icons/pi';
import { WhatsappShareButton } from 'react-share';
import styled from 'styled-components';

import { Environment } from '../../constants/environments';
import { useEventContext } from '../../hooks/contexts/event.context';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import Tooltip from '../Tooltip';
import * as Styles from './styles.share';

const WhatsAppShareButton = styled(WhatsappShareButton)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ShareEvent = () => {
  const { event } = useEventContext();
  const { translate } = useI18nContext();
  const [showTooltip, setShowTooltip] = useState(false);

  const onClickCopyEvent = () => {
    setShowTooltip(true);
    navigator?.clipboard?.writeText(`${Environment.INGRESSE_URL}/${event?.slug}`);
  };

  return (
    <Styles.Wrapper id="share-event-wrapper">
      <WhatsAppShareButton
        windowWidth={window.innerWidth}
        windowHeight={window.innerHeight}
        data-testid="whatsapp-share-button-event-page"
        url={`${Environment.INGRESSE_URL}/${event?.slug}`}
        title={`${event?.title} -`}
      >
        <Styles.Background>
          <PiWhatsappLogo size="32px" color='#454F5B' />
        </Styles.Background>
        <Styles.Text>{translate(['SHARE_EVENT', 'WHATSAPP'])}</Styles.Text>
      </WhatsAppShareButton>

      <Styles.Grouper onClick={onClickCopyEvent} data-testid="copy-button-event-page">
        {showTooltip &&
          <Tooltip message={translate(['SHARE_EVENT', 'COPIED'])} data-testid="tooltip-event-page" />
        }
        <Styles.Background>
          <IoCopyOutline size="32px" color='#454F5B' />
        </Styles.Background>
        <Styles.Text>{translate(['SHARE_EVENT', 'COPY'])}</Styles.Text>
      </Styles.Grouper>

    </Styles.Wrapper>
  );
};

export default ShareEvent;
